/**
 * "Como chegar" — abre a rota e deixa o TELEFONE escolher o app.
 *
 * Havia um sheet próprio ("Apple Maps, Google Maps ou Waze?") com "sempre
 * abrir com este" guardado neste aparelho e uma escolha no Perfil. O teste
 * físico mostrou que isso repete o que o sistema já faz: no Android, o
 * `geo:` abre o seletor nativo e "sempre" é configuração do aparelho. Regra
 * das URLs em @nv/core (`deviceNavigationUrl`).
 */
import { deviceNavigationUrl, platformFromUserAgent, type NavigationPlatform, type NavigationTarget } from '@nv/core';
import type { ReactNode } from 'react';

export function plataformaDoAparelho(): NavigationPlatform {
  if (typeof navigator === 'undefined') return 'other';
  return platformFromUserAgent(navigator.userAgent, navigator.maxTouchPoints ?? 0);
}

export function ComoChegar({
  destino,
  className = 'nv-btn nv-btn--secondary',
  children,
}: {
  destino: NavigationTarget;
  className?: string;
  children?: ReactNode;
}) {
  const plataforma = plataformaDoAparelho();
  const url = deviceNavigationUrl(destino, plataforma);
  if (!url) return null;

  // `geo:` não abre em aba nova (é o sistema que atende); os links web sim.
  const externo = url.startsWith('http');
  return (
    <a
      className={className}
      href={url}
      target={externo ? '_blank' : undefined}
      rel={externo ? 'noopener noreferrer' : undefined}
      data-testid="como-chegar"
      data-plataforma={plataforma}
    >
      {children ?? 'Como chegar'}
    </a>
  );
}
